var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4375 9.12992H5.90633V14.5619C5.90633 14.8034 6.10175 14.9994 6.34383 14.9994L8.68125 15C8.92333 15 9.11875 14.8034 9.11875 14.5625V9.1305H10.5112C10.7317 9.1305 10.9178 8.966 10.9452 8.74725L11.2357 6.41392C11.2683 6.15375 11.0648 5.92217 10.8017 5.92217H9.11875C9.18467 4.48075 8.865 4.05433 9.80242 4.05433C10.4371 3.9785 11.4381 4.29992 11.4381 3.61683V1.53025C11.4381 1.3115 11.2765 1.12658 11.0601 1.09683C10.8769 1.07175 10.153 1 9.25525 1C5.16608 1 6.00783 5.53367 5.90692 5.92158H4.4375C4.196 5.92158 4 6.11758 4 6.35908V8.69242C4 8.93392 4.196 9.12992 4.4375 9.12992ZM4.875 6.79717H6.34383C6.58533 6.79717 6.78133 6.60117 6.78133 6.35967V4.52158C6.78133 2.83983 7.68258 1.87558 9.25467 1.87558C9.76683 1.87558 10.2382 1.90067 10.5625 1.92633V3.17992C10.328 3.2995 8.24317 2.66425 8.24317 4.75317V6.36025C8.24317 6.60175 8.43917 6.79775 8.68067 6.79775H10.3058L10.1238 8.25608H8.68067C8.43917 8.25608 8.24317 8.45208 8.24317 8.69358V14.125H6.78192V8.693C6.78192 8.4515 6.58592 8.2555 6.34442 8.2555H4.875V6.79717Z",
    fill: "#1F82FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.195347890dc6b10d1d58027417350dab.svg";
export { ForwardRef as ReactComponent };